interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: "primary" | "secondary" | "outline";
  size?: "sm" | "md" | "lg";
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
}

export default function Button({
  children,
  onClick,
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
  disabled = false,
}: ButtonProps) {
  const baseClasses =
    "font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center";

  const variants = {
    primary:
      "text-white hover:bg-opacity-90 focus:ring-4 focus:ring-opacity-30",
    secondary:
      "bg-gray-600 text-white hover:bg-gray-700 focus:ring-4 focus:ring-gray-300",
    outline:
      "border-2 text-white hover:bg-opacity-90 hover:text-white focus:ring-4 focus:ring-opacity-30",
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${className}`}
      style={
        variant === "primary"
          ? { backgroundColor: "#43d1c7" }
          : variant === "outline"
          ? { borderColor: "#43d1c7", color: "#43d1c7" }
          : undefined
      }
    >
      {children}
    </button>
  );
}
